import { WrenchIcon } from "@visma-netvisor/nv-react-icons";
import { Button, EmptyState } from "@visma-netvisor/react-component-library";
import { useTranslation } from "react-i18next";

export const SomethingWentWrong = () => {
  const { t } = useTranslation();
  return (
    <>
      <EmptyState
        actions={
          <>
            <Button
              onClick={() =>
                (window.location.href = "https://netvisor.fi/hinnoittelu/")
              }
            >
              {t("General.Back")}
            </Button>
          </>
        }
        description={"Something went wrong"}
        heading="Something went wrong"
        icon={WrenchIcon}
      />
    </>
  );
};
